import SegmentedToggle from './SegmentedToggle.component';

export default SegmentedToggle;
